module.exports = __webpack_public_path__ + "static/media/_macao.444e223e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_macao.svg
// module id = 2335
// module chunks = 7